import { render } from "./DashboardSidebar.vue?vue&type=template&id=8126e98e&scoped=true"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=8126e98e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8126e98e"]])

export default __exports__